import React from 'react'
import PropTypes from 'prop-types'
/**
 * @summary More
 * @component
 *
 * @param {object} props
 *
 * @returns {node} jsx markup
 */
function More({ styling }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={styling}
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
    </svg>
  )
}
// PROPTYPES
const { string } = PropTypes
More.propTypes = {
  styling: string,
}

export default More
